import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { LocalNotification } from '@amzn/aac-chrome-internal-api';
import { bannerMetricsPublisher } from 'src/features/header/components/Banners/types';
import { logWithTakt } from '../../utils/logWithTakt';
import { BANNER_LEVEL } from 'src/app/slice';
import { AcesBannerContent } from './AcesBannerContent';
import { clickLinkHandler } from './utils';
import { BannerContentWrapper, BannerLink } from './styles';
import { BannerText } from 'src/features/header/components/Banners/styles';

interface BannerContentProps {
  banner: LocalNotification;
  bannerLevel: BANNER_LEVEL;
  isRenderedInModal?: boolean;
}

export const BannerContent: React.VFC<BannerContentProps> = ({
  banner,
  bannerLevel,
  isRenderedInModal = true,
}) => {
  useEffect(() => {
    bannerMetricsPublisher[bannerLevel].publishCounterMonitor(
      `${bannerLevel}BannerRendered:${banner.id}`,
      1,
    );
    logWithTakt(`${bannerLevel}BannerRendered`, { bannerId: banner.id });
  }, []);

  const acesBannerContent = banner.acesBannerContent;
  return acesBannerContent ? (
    <AcesBannerContent
      acesBannerContent={acesBannerContent}
      bannerLevel={bannerLevel}
      bannerId={banner.id}
      bannerType={banner.type}
    />
  ) : (
    <BannerContentWrapper isRenderedInModal={isRenderedInModal}>
      {banner.title && (
        <BannerText>
          <strong>{banner.title}</strong>
        </BannerText>
      )}
      {(isRenderedInModal || (!isRenderedInModal && !banner.title)) && (
        <BannerText>{banner.message}</BannerText>
      )}
      {banner.link && (
        <BannerLink
          size="small"
          href={banner.link.url}
          aria-label={banner.message + banner.link.label}
          onClick={() => clickLinkHandler(bannerLevel, banner.id)}
          isRenderedInModal={isRenderedInModal}
        >
          {banner.link.label}
        </BannerLink>
      )}
    </BannerContentWrapper>
  );
};

// Still connected (rather than exporting BannerContent directly) so the many
// call sites importing ConnectedBannerContent keep working; it currently maps
// neither state nor dispatch.
export const ConnectedBannerContent = connect()(BannerContent);
